module.exports = "../dist/frontend/icons/ui/categoryOther.svg?f54633a59f0d9aadfed4802d594dbfab";